import { useSelector } from "react-redux";
import { Option, User } from "./types";

interface GoogleProfile {
  sub: string;
  name: string;
  givenName: string;
  familyName: string;
  picture: string;
  email: string;
  emailVerified: boolean;
  hd: string;
}

export const useUser = () => useSelector((state) => (state as { personal: { user: User } }).personal.user);

export const useValidRoutingNumberOptions = () =>
  useSelector(
    (state) =>
      (state as { personal: { validRoutingNumberOptions: Option[] } }).personal.validRoutingNumberOptions,
  );

export const useGmailUnsync = () =>
  useSelector((state) => (state as { personal: { gmailUnsync: boolean } }).personal.gmailUnsync);

export const useGoogleAuthUrl = () =>
  useSelector((state) => (state as { personal: { googleAuthUrl: string } }).personal.googleAuthUrl);

export const useMlsOptions = () =>
  useSelector((state) => (state as { personal: { mlsOptions: Option[] } }).personal.mlsOptions);

export const useEmailPlaceholders = () =>
  useSelector((state) => (state as { personal: { emailPlaceholders: Option[] } }).personal.emailPlaceholders);

export const useGoogleProfile = () =>
  useSelector((state) => (state as { personal: { googleProfile: GoogleProfile } }).personal.googleProfile);

export const usePersonalLoading = () =>
  useSelector((state) => (state as { personal: { loading: boolean } }).personal.loading);

export const usePersonalErrors = () =>
  useSelector((state) => (state as { personal: { errors: { [key: string]: string[] } } }).personal.errors);
